import React from "react";

export function HorizontalNote(props: { children: React.ReactNode }) {
  return (
    <div className="field is-horizontal">
      <div className="field-label is-normal" />
      <div className="field-body is-italic">
        <div>{props.children}</div>
      </div>
    </div>
  );
}
